import { RegisterModule } from '@/typings/common'
import {
  PermissionGroupsState,
  PermissionGroupsGetters,
  PermissionGroupsMutations,
  PermissionGroupsActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: PermissionGroupsState,
    getters: PermissionGroupsGetters,
    mutations: PermissionGroupsMutations,
    actions: PermissionGroupsActions,
  })
)

const storeMapper = createMapper(storeModule)

export {
  storeModule as permissionsGroupsStoreModule,
  storeMapper as permissionsGroupsStoreMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
